import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadImageArea = _resolveComponent("UploadImageArea")!
  const _component_SetImageModal = _resolveComponent("SetImageModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UploadImageArea, {
      title: _ctx.title,
      appLabelText: _ctx.appLabelText,
      appLabelVariant: _ctx.appLabelVariant,
      onClickCamera: _ctx.startCamera,
      onClickSelect: _ctx.startFileSelect
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ], undefined, true),
      _: 3
    }, 8, ["title", "appLabelText", "appLabelVariant", "onClickCamera", "onClickSelect"]),
    _createTextVNode(),
    _withDirectives(_createVNode(_component_SetImageModal, {
      ref: "setImageModal",
      photographingType: _ctx.photoGraphingType,
      isCameraActive: _ctx.isCameraActiveValue,
      "onUpdate:isCameraActive": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCameraActiveValue) = $event)),
      isFrontCamera: _ctx.isFrontCamera,
      options: _ctx.options,
      modalType: _ctx.modalType,
      onCloseModal: _ctx.closeSetImageModal,
      onOpenModal: _ctx.openSetImageModal,
      onInput: _ctx.onInputImageData,
      onChangeImage: _ctx.openSetImageModal,
      roundedButton: "",
      imageDescription: _ctx.imageDescription
    }, null, 8, ["photographingType", "isCameraActive", "isFrontCamera", "options", "modalType", "onCloseModal", "onOpenModal", "onInput", "onChangeImage", "imageDescription"]), [
      [_vShow, _ctx.isSetImageModalOpen]
    ])
  ]))
}